module.exports = __webpack_public_path__ + "img/Logotipo 1.c77df660.png";